import { digofHttp as axios } from "@/axios";
import {UPDATE} from '@/query/notifikasi'; 
// import {DELETE} from '@/query/notifikasi';

function store(data){
  axios.post('notification/store', data)
  .catch(e => {
    console.error(e);
  });
}

function update(notificationId){
  this.$apollo
  .mutate({
    mutation: UPDATE,
    variables: {
      id : notificationId,
      input: {is_read : 0}
    }
  }).catch(error => {
    console.log(error);
    this.$vs.dialog({
      color: "danger",
      title: "Terjadi Kesalahan",
      text: "Error saat update notifikasi !"
    });
  });
}

function deleteNotification(id){
  console.log(id);
}

export {
  store,
  update,
  deleteNotification
}